<template>
    <div>
        <rkm-form
            v-if="model"
            ref="RkmForm"
            :show-legend="model.items.length > 0"
        >
            <rkm-area type="fieldset" title="Dados da dispensação">
                <rkm-row>
                    <rkm-col cols="9">
                        <rkm-form-input-autocomplete
                            :disabled="disableField()"
                            :repository="repositories.usuario"
                            :requestQueryStringParams="{ with_not_regularized: true }"
                            :searchFields="fields.autocomplete.usuario"
                            :validations="validations.medicoSolicitante"
                            label="Médico solicitante"
                            placeholder="Digite o nome ou número do conselho profissional"
                            v-model="model.medicoSolicitante"
                            text-field="cidadaoNome"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <rkm-form-date-picker
                            :disabled="disableField()"
                            :max-date="form.dataAtual"
                            :validations="validations.dataDispensacao"
                            v-model="model.dataDispensacao"
                            label="Data"
                            right
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col>
                        <rkm-form-textarea
                            label="Observações"
                            v-model="model.observacao"
                            :validations="validations.observacao"
                        />
                    </rkm-col>
                </rkm-row>
            </rkm-area>
        </rkm-form>

        
        <rkm-area type="fieldset" title="Adicionar material">
            <rkm-row v-if="!disableField()">
                <rkm-col>
                    <FormItem
                        :form="form"
                        :model="model"
                        @save="handleSave"
                        ref="Form"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>

        <rkm-area type="fieldset" :title="`Materiais (${ model.items.length })`">
            <rkm-row>
                <rkm-col>
                    <ListItem
                        ref="ListItem"
                        @save="handleSaveItem"
                        :form="form"
                        :model="model"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>
    </div>
</template>

<script>
import { repository, object, data } from '@/mixins'
import FormItem from './item/Form'
import ListItem from './item/List'

export default {
    components: {
        FormItem,
        ListItem
    },
    created() {
        this.repositories = {
            usuario: this.getConectaSusRepository('cadastro.sujeitoAtencao.usuario'),
            cid: this.getConectaSusRepository('sigtap.cid'),
        }
    },
    computed: {
        fields() {
            return {
                autocomplete: {
                    usuario: [
                        { key: "cadastroCidadao.nome", searchable: true },
                        { key: "cadastroUsuario.registroNumero", searchable: true },
                    ],
                    cid: [{ key: "nome", searchable: true }],
                }
            }
        },
        validations() {
            return {
                medicoSolicitante: { required: true },
                dataDispensacao: { required: true },
                observacao: { min: 3, max:300 },
                numeroNotificacao: { max: 8 },
            }
        }
    },
    methods: {
        disableField() {
            return this.model && Number(this.model.id) > 0
        },
        save() {
            if(this.model.items.length > 0) {
                this.$refs.RkmForm.validate()
                    .then(valid => {
                        if (!valid) return
                        this.$emit('save')
                    })
            } else {
                this.$emit('save')
            }
        },
        handleSave(item) {
            const itemClone = this.clone(item)
            itemClone.dispensadoEm = this.getFormatedDate(item.dispensadoEm, 'DD/MM/YYYY', 'YYYY-MM-DD')
            const hasMaterial = this.model.items.some(i => i.material.id == itemClone.material.id && i.id != item.id)
            if(hasMaterial) {
                this.showWarningNotification("Este item já está na lista!")
                return
            }
            if(itemClone.id) {
                const idx = this.model.items.findIndex(i => i.id === itemClone.id)
                Object.assign(this.model.items[idx], itemClone)
                this.clearForm()
            } else {
                itemClone.id = `${new Date().getTime()}-receita-item`
                this.model.items.push(itemClone)
                this.clearForm()
            }
        },
        clearForm() {
            this.model.item.material = null
            this.model.item.estoque = null
            this.model.item.dispensadoEm = null
            this.model.item.quantidade = null
            this.model.item.observacao = null
        },
        handleSaveItem() {
        },
    },
    mixins: [ repository, object, data ],
    props: {
        form: { type: Object, default: null },
        model: { type: Object, default: null },
    }
}
</script>